export const PossibleSuffixes = [
  {
    name: 'None',
    key: ''
  },
  {
    name: 'JR',
    key: 'JR'
  },
  {
    name: 'SR',
    key: 'SR'
  },
  {
    name: 'II',
    key: 'II'
  },
  {
    name: 'III',
    key: 'III'
  },
  {
    name: 'IV',
    key: 'IV'
  },
  {
    name: 'V',
    key: 'V'
  },
  {
    name: 'VI',
    key: 'VI'
  },
  {
    name: 'VII',
    key: 'VII'
  },
  {
    name: 'VIII',
    key: 'VIII'
  },
  {
    name: 'IX',
    key: 'IX'
  },
  {
    name: 'X',
    key: 'X'
  }
];

export const PossibleSuffixesNext = [
  {
    display: 'None',
    value: ''
  },
  {
    display: 'Jr',
    value: 'JR'
  },
  {
    display: 'Sr',
    value: 'SR'
  },
  {
    display: 'II',
    value: 'II'
  },
  {
    display: 'III',
    value: 'III'
  },
  {
    display: 'IV',
    value: 'IV'
  },
  {
    display: 'V',
    value: 'V'
  },
  {
    display: 'VI',
    value: 'VI'
  },
  {
    display: 'VII',
    value: 'VII'
  },
  {
    display: 'VIII',
    value: 'VIII'
  },
  {
    display: 'IX',
    value: 'IX'
  },
  {
    display: 'X',
    value: 'X'
  }
];
